import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styled from 'styled-components';

const defaultProps = {
    duration: 0.3,
    isAnimate: true,
    isShow: false,
};

const propTypes = {
    duration: PropTypes.number,
    isAnimate: PropTypes.bool,
    isShow: PropTypes.bool,
};

const AccordionBody = styled.div`
    max-height: ${props => props.maxHeight || null};
    overflow: hidden;
    transition: max-height ${({ duration }) => duration}s ease;
    width: 100%;
`;

export class AccordionAnimateBody extends Component {
    static propTypes = propTypes;
    static defaultProps = defaultProps;

    constructor(props) {
        super(props);
        this.state = { maxHeight: '0px' };
        this.bodyRef = React.createRef();
    }

    bodyHide = () => {
        if (this.props.isAnimate === false) {
            this.setState({ maxHeight: '0px' });
            return;
        }

        this.setState({ maxHeight: `${this.bodyRef.current.scrollHeight}px` });
        this.bodyRef.current.offsetHeight;
        this.setState({ maxHeight: '0px' });
    }

    bodyShow = () => {
        if (this.props.isAnimate === false) {
            this.clearStyle();
            return;
        }

        this.setState({ maxHeight: `${this.bodyRef.current.scrollHeight}px` });
    }

    clearStyle = () => {
        this.setState({ maxHeight: null });
    }

    componentDidMount() {
        if (this.props.isShow === false) {
            this.setState({ maxHeight: '0px' });
        }
    }

    componentDidUpdate({ isShow }) {
        if (isShow !== this.props.isShow) {
            if (this.props.isShow === true) {
                this.bodyShow();
            } else {
                this.bodyHide();
            }
        }
    }

    render() {
        return (
            <AccordionBody
                maxHeight={this.state.maxHeight}
                duration={this.props.duration}
                ref={this.bodyRef}
                onTransitionEnd={this.props.isShow === true
                    ? this.clearStyle
                    : () => {
                    return;
                }}
                data-test={'AccordionBody'}
                {...this.props}
            >
                {this.props.children}
            </AccordionBody>
        );
    }
}
